import request from '@/utils/request';
export function getTraceCodeRecordList(data) {
    return request({
      url: `/wlDevice/queryPageTraceCode`,
      method: 'post',
      data
    });
}
export function getTraceCodeList(data) {
    return request({
      url: `/wlDevice/queryPage`,
      method: 'post',
      data
    });
}
export function editTraceCode(data) {
    return request({
      url: `/wlDevice/editDevice`,
      method: 'post',
      data
    });
}
export function addTraceCode(data) {
    return request({
      url: `/wlDevice/addDevice`,
      method: 'post',
      data
    });
}
export function getTraceCode(id) {
    return request({
      url: `/wlDevice/query/${id}`,
      method: 'get',
    });
}
export function getWlOpenDoorInfo(data) {
    return request({
      url: `/wlOpenDoorInfo/queryPage`,
      method: 'post',
      data
    });
}